import styled from '@emotion/styled';
import { Alert } from '@qga/roo-ui/components';
import { themeGet } from '@styled-system/theme-get';
import useAlert from 'hooks/useAlert';

const StyledAlert = styled(Alert)`
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: ${themeGet('zIndices.alerts')};
  min-height: 48px;
  margin: 0;
  font-size: 16px;
  font-weight: bold;

  animation: 6s showAlert;
  animation-fill-mode: forwards;
  @keyframes showAlert {
    0% {
      transform: translateY(-100%);
      opacity: 1;
    }
    8.333% {
      transform: translateY(0);
      opacity: 1;
    }
    91.666% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-100%);
      opacity: 0;
    }
  }

  > div > div {
    justify-content: center;
    > div {
      padding-right: 8px;
    }
  }
`;

const StickyAlert = () => {
  const { alert } = useAlert();

  if (!alert) {
    return null;
  }

  const { type, message } = alert;

  return (
    <StyledAlert variant={type} data-testid="sticky-alert" aria-live="assertive">
      {message}
    </StyledAlert>
  );
};

export default StickyAlert;
